// Push Notification Utilities

const PUBLIC_VAPID_KEY = 'BEl62iUYgUivxIkv69yViEuiBIa-Ib9-SkvMeAtA3LFgDzkrxZJjSgSnfckjBJuBkr3qBUYIHBQFLXYp5Nksh8U';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export const isPushSupported = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window;
};

export const getNotificationPermission = () => {
  if (!isPushSupported()) return 'unsupported';
  return Notification.permission;
};

export const requestNotificationPermission = async () => {
  if (!isPushSupported()) {
    return { success: false, error: 'Push notificaties worden niet ondersteund in deze browser' };
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      return { success: true, permission };
    } else {
      return { success: false, error: 'Notificatie toestemming geweigerd' };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const registerServiceWorker = async () => {
  if (!isPushSupported()) {
    return { success: false, error: 'Service workers worden niet ondersteund' };
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js');
    await navigator.serviceWorker.ready;
    return { success: true, registration };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const subscribeToPush = async () => {
  try {
    const { success, registration, error } = await registerServiceWorker();
    if (!success) return { success: false, error };

    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(PUBLIC_VAPID_KEY)
    });

    return { success: true, subscription: subscription.toJSON() };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const unsubscribeFromPush = async () => {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    if (subscription) {
      await subscription.unsubscribe();
    }
    
    return { success: true };
  } catch (error) {
    return { success: false, error: error.message };
  }
};

export const getCurrentSubscription = async () => {
  try {
    if (!isPushSupported()) return null;
    
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    return subscription ? subscription.toJSON() : null;
  } catch (error) {
    console.error('Error getting subscription:', error);
    return null;
  }
};

export const showLocalNotification = async (title, body) => {
  if (!isPushSupported()) return false;
  
  try {
    const registration = await navigator.serviceWorker.ready;
    await registration.showNotification(title, {
      body,
      icon: '/logo192.png',
      badge: '/logo192.png',
      vibrate: [100, 50, 100]
    });
    return true;
  } catch (error) {
    console.error('Error showing notification:', error);
    return false;
  }
};

// Smart notification - only show if revenue not filled
export const showSmartRevenueNotification = async (api, frequency = 'dagelijks') => {
  try {
    // Check if revenue is filled for the current period
    const response = await api.get(`/alerts/check-revenue-filled?period=${frequency}`);
    const { should_remind, period_label } = response.data;
    
    if (should_remind) {
      const periodType = frequency === 'dagelijks' ? 'dag' : 
                        frequency === 'wekelijks' ? 'week' : 
                        frequency === 'maandelijks' ? 'maand' : 'jaar';
      
      await showLocalNotification(
        `Omzet Herinnering`,
        `Je hebt nog geen omzet ingevuld voor ${period_label}. Vergeet niet je ${periodType}omzet te registreren!`
      );
      return { notified: true, reason: 'no_revenue' };
    } else {
      return { notified: false, reason: 'already_filled' };
    }
  } catch (error) {
    console.error('Error checking revenue:', error);
    // Fallback to always notify if check fails
    await showLocalNotification(
      'Omzet Herinnering',
      'Vergeet niet je omzet in te vullen!'
    );
    return { notified: true, reason: 'fallback' };
  }
};
